export default function GiveQueryObjReturnValueObj(arr) {
  let success = false;
  try {
    if (typeof arr === "object") {
      let currentUrl = window.location.href; // Get the current URL
      let queryString = String(currentUrl).split("?")[1]; //Extract the query string from the URL
      let params = queryString.split("&"); //Split the query string into individual parameter-value pairs

      //Iterate through the parameter-value pairs to find the desired parameter and retrieve its value
      let obj = {};
      for (let i = 0; i < arr.length; i++) {
        for (let _i = 0; _i < params.length; _i++) {
          let param = params[_i].split("=");
          if (param[0] === arr[i]) {
            obj[arr[i]] = decodeURI(param[1]);
          }
        }
      }
      success = true;
      obj["success"] = success;

      return obj;
    }

    return {
      msg: `You give me a ${typeof arr}, i received only array`,
      success,
    };
  } catch (error) {
    return {
      msg: "Some error occurred from GiveQueryObjReturnValueObj",
      success,
    };
  }
}
